import { Box, ModalHeader, Text } from "@chakra-ui/react";
import { FC, memo } from "react";
import { IconType } from "react-icons";
import { AiFillCloseCircle } from "react-icons/ai";
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation";

type Props ={
    TopicAuthorName : string
    TypeMenu: string
    ModalIcon: IconType
    onClose : () => void
}

export const MyModalHeader:FC<Props> = memo((props)=> {
    const {TopicAuthorName, TypeMenu, ModalIcon, onClose} = props
    return(
        <ModalHeader 
         display="flex" 
         className={`${TypeMenu} dialog_title_outer`} 
         h={`${HeightCalculation(98,98)}px`} 
         padding={`${HeightCalculation(24,24)}px`}
        > 
            <Box display="flex">
                <Box 
                 borderRadius="100%" 
                 boxSize={`${HeightCalculation(50,50)}px`}
                 mr={`${WidthCalculation(16,16)}px`}
                >
                    <ModalIcon size={`${HeightCalculation(50,50)}px`} color="white" />
                </Box>
                <Text 
                style={{ userSelect: "none" }} 
                className='header' 
                fontSize={`${HeightCalculation(36,36)}px`}
                lineHeight={`${HeightCalculation(50,50)}px`}
                justifyContent="center"
                >
                  {TopicAuthorName}
                </Text>
            </Box> 
            <Box
              borderRadius="100%"
              as="div"
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              width={`${WidthCalculation(48,48)}px`}
              height={`${HeightCalculation(48,48)}px`}
              fontSize={`${HeightCalculation(48,48)}px`}
              color="white"
              onClick={onClose}
            >
              <AiFillCloseCircle />
            </Box>
      </ModalHeader>
    )
})